<div class="component-content">
  <router-outlet></router-outlet>
</div>
